export default __webpack_public_path__ + "static/media/kepviselo.0f90777e.png";